import * as $runtime from "../runtime.js";
import * as Data$dDate from "../Data.Date/index.js";
import * as Data$dEnum$dGeneric from "../Data.Enum.Generic/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dSet$dSerialized from "../Data.Set.Serialized/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dGeneric$dEnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dCalendar$dTypes$dAvailability from "../Restaumatic.Calendar.Types.Availability/index.js";
import * as Restaumatic$dCalendar$dTypes$dRestaurantLocalDay from "../Restaumatic.Calendar.Types.RestaurantLocalDay/index.js";
import * as Restaumatic$dI18n$dTypes from "../Restaumatic.I18n.Types/index.js";
import * as Restaumatic$dLocales from "../Restaumatic.Locales/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dMenuConsumer from "../Restaumatic.Menu.V2.Types.MenuConsumer/index.js";
import * as Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion from "../Restaumatic.PromotionsEngine.Promotions.Types.Promotion/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dEnum from "../Unscramble.Enum/index.js";
const $AvailableAt = tag => ({tag});
const Everywhere = /* #__PURE__ */ $AvailableAt("Everywhere");
const DeliveryOnly = /* #__PURE__ */ $AvailableAt("DeliveryOnly");
const RestaurantOnly = /* #__PURE__ */ $AvailableAt("RestaurantOnly");
const TakeawayOnly = /* #__PURE__ */ $AvailableAt("TakeawayOnly");
const DeliveryAndTakeaway = /* #__PURE__ */ $AvailableAt("DeliveryAndTakeaway");
const RestaurantAndTakeaway = /* #__PURE__ */ $AvailableAt("RestaurantAndTakeaway");
const Promotion = x => x;
const newtypePromotion_ = {Coercible0: () => {}};
const hasFieldPromotion = dictHasField => dictHasField;
const eqAvailableAt = {
  eq: x => y => {
    if (x.tag === "Everywhere") { return y.tag === "Everywhere"; }
    if (x.tag === "DeliveryOnly") { return y.tag === "DeliveryOnly"; }
    if (x.tag === "RestaurantOnly") { return y.tag === "RestaurantOnly"; }
    if (x.tag === "TakeawayOnly") { return y.tag === "TakeawayOnly"; }
    if (x.tag === "DeliveryAndTakeaway") { return y.tag === "DeliveryAndTakeaway"; }
    if (x.tag === "RestaurantAndTakeaway") { return y.tag === "RestaurantAndTakeaway"; }
    return false;
  }
};
const eqPromotion = {
  eq: x => y => x.allowRosCouponsGeneration === y.allowRosCouponsGeneration && x.archived === y.archived && Restaumatic$dCalendar$dTypes$dAvailability.eqWeeklyAvailability.eq(x.availability)(y.availability) && (() => {
    if (x.availableAt.tag === "Everywhere") { return y.availableAt.tag === "Everywhere"; }
    if (x.availableAt.tag === "DeliveryOnly") { return y.availableAt.tag === "DeliveryOnly"; }
    if (x.availableAt.tag === "RestaurantOnly") { return y.availableAt.tag === "RestaurantOnly"; }
    if (x.availableAt.tag === "TakeawayOnly") { return y.availableAt.tag === "TakeawayOnly"; }
    if (x.availableAt.tag === "DeliveryAndTakeaway") { return y.availableAt.tag === "DeliveryAndTakeaway"; }
    if (x.availableAt.tag === "RestaurantAndTakeaway") { return y.availableAt.tag === "RestaurantAndTakeaway"; }
    return false;
  })() && Data$dEq.eqArrayImpl(Data$dEq.eqIntImpl)(x.combineTo._1)(y.combineTo._1) && Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.eqPromotionConditions.eq(x.conditions)(y.conditions) && Data$dMap$dInternal.eqMap(Restaumatic$dLocales.eqLocale)(Data$dEq.eqString).eq(x.description)(y.description) && x.enableAutoselect === y.enableAutoselect && Data$dMap$dInternal.eqMap(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.eqMenuConsumer)(Data$dEq.eqUnit).eq(x.enabledMenuConsumers)(y.enabledMenuConsumers) && Data$dDate.eqDate.eq(x.finish)(y.finish) && (() => {
    if (x.groupId.tag === "Nothing") { return y.groupId.tag === "Nothing"; }
    if (x.groupId.tag === "Just") {
      if (y.groupId.tag === "Just") { return x.groupId._1 === y.groupId._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.imageUrl.tag === "Nothing") { return y.imageUrl.tag === "Nothing"; }
    if (x.imageUrl.tag === "Just") {
      if (y.imageUrl.tag === "Just") { return x.imageUrl._1 === y.imageUrl._1; }
      return false;
    }
    return false;
  })() && Data$dMap$dInternal.eqMap(Restaumatic$dLocales.eqLocale)(Data$dEq.eqString).eq(x.name)(y.name) && Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.eqPromotionPrize.eq(x.prize)(y.prize) && x.promotionId === y.promotionId && (() => {
    if (x.promotionType.tag === "Standard") { return y.promotionType.tag === "Standard"; }
    if (x.promotionType.tag === "InformationOnly") { return y.promotionType.tag === "InformationOnly"; }
    if (x.promotionType.tag === "RequiresCoupon") { return y.promotionType.tag === "RequiresCoupon"; }
    return false;
  })() && (() => {
    if (x.requireSmsVerification.tag === "Nothing") { return y.requireSmsVerification.tag === "Nothing"; }
    if (x.requireSmsVerification.tag === "Just") {
      if (y.requireSmsVerification.tag === "Just") { return x.requireSmsVerification._1 === y.requireSmsVerification._1; }
      return false;
    }
    return false;
  })() && x.requiresMarketing === y.requiresMarketing && x.restaurantId === y.restaurantId && Data$dDate.eqDate.eq(x.start)(y.start) && x.visible === y.visible
};
const ordAvailableAt = {
  compare: x => y => {
    if (x.tag === "Everywhere") {
      if (y.tag === "Everywhere") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Everywhere") { return Data$dOrdering.GT; }
    if (x.tag === "DeliveryOnly") {
      if (y.tag === "DeliveryOnly") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "DeliveryOnly") { return Data$dOrdering.GT; }
    if (x.tag === "RestaurantOnly") {
      if (y.tag === "RestaurantOnly") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "RestaurantOnly") { return Data$dOrdering.GT; }
    if (x.tag === "TakeawayOnly") {
      if (y.tag === "TakeawayOnly") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "TakeawayOnly") { return Data$dOrdering.GT; }
    if (x.tag === "DeliveryAndTakeaway") {
      if (y.tag === "DeliveryAndTakeaway") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "DeliveryAndTakeaway") { return Data$dOrdering.GT; }
    if (x.tag === "RestaurantAndTakeaway") {
      if (y.tag === "RestaurantAndTakeaway") { return Data$dOrdering.EQ; }
      $runtime.fail();
    }
    $runtime.fail();
  },
  Eq0: () => eqAvailableAt
};
const genericPromotion = {to: x => x, from: x => x};
const genericAvailableAt = {
  to: x => {
    if (x.tag === "Inl") { return Everywhere; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return DeliveryOnly; }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return RestaurantOnly; }
        if (x._1._1.tag === "Inr") {
          if (x._1._1._1.tag === "Inl") { return TakeawayOnly; }
          if (x._1._1._1.tag === "Inr") {
            if (x._1._1._1._1.tag === "Inl") { return DeliveryAndTakeaway; }
            if (x._1._1._1._1.tag === "Inr") { return RestaurantAndTakeaway; }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Everywhere") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "DeliveryOnly") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "RestaurantOnly") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))); }
    if (x.tag === "TakeawayOnly") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))));
    }
    if (x.tag === "DeliveryAndTakeaway") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
      );
    }
    if (x.tag === "RestaurantAndTakeaway") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))))
      );
    }
    $runtime.fail();
  }
};
const showAvailableAt = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Everywhere"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "DeliveryOnly"});
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "RestaurantOnly"});
    const $3 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "TakeawayOnly"});
    const $4 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "DeliveryAndTakeaway"});
    const $5 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "RestaurantAndTakeaway"});
    return x => {
      const $6 = genericAvailableAt.from(x);
      if ($6.tag === "Inl") { return $0["genericShow'"]($6._1); }
      if ($6.tag === "Inr") {
        if ($6._1.tag === "Inl") { return $1["genericShow'"]($6._1._1); }
        if ($6._1.tag === "Inr") {
          if ($6._1._1.tag === "Inl") { return $2["genericShow'"]($6._1._1._1); }
          if ($6._1._1.tag === "Inr") {
            if ($6._1._1._1.tag === "Inl") { return $3["genericShow'"]($6._1._1._1._1); }
            if ($6._1._1._1.tag === "Inr") {
              if ($6._1._1._1._1.tag === "Inl") { return $4["genericShow'"]($6._1._1._1._1._1); }
              if ($6._1._1._1._1.tag === "Inr") { return $5["genericShow'"]($6._1._1._1._1._1); }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const showPromotion = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dMap$dInternal.showMap(Restaumatic$dLocales.showLocale)(Data$dShow.showString);
      const $1 = Data$dSet.showSet(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.showMenuConsumer);
      const $2 = Data$dMap$dInternal.showMap(Restaumatic$dLocales.showLocale)(Data$dShow.showString);
      return {
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["allowRosCouponsGeneration", v.allowRosCouponsGeneration ? "true" : "false"]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "archived",
              v.archived ? "true" : "false"
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["availability", Restaumatic$dCalendar$dTypes$dAvailability.showWeeklyAvailability.show(v.availability)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "availableAt",
              showAvailableAt.show(v.availableAt)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["combineTo", Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.showPromotionFilter.show(v.combineTo)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "conditions",
              Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.showPromotionConditions.show(v.conditions)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["description", $2.show(v.description)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "enableAutoselect",
              v.enableAutoselect ? "true" : "false"
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["enabledMenuConsumers", $1.show(v.enabledMenuConsumers)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "finish",
              Restaumatic$dCalendar$dTypes$dRestaurantLocalDay.showRestaurantLocalDay.show(v.finish)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "groupId",
              (() => {
                if (v.groupId.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v.groupId._1) + ")"; }
                if (v.groupId.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "imageUrl",
              (() => {
                if (v.imageUrl.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v.imageUrl._1) + ")"; }
                if (v.imageUrl.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["name", $0.show(v.name)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "prize",
              Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.showPromotionPrize.show(v.prize)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["promotionId", Data$dShow.showIntImpl(v.promotionId)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "promotionType",
              Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.showPromotionType.show(v.promotionType)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "requireSmsVerification",
              (() => {
                if (v.requireSmsVerification.tag === "Just") {
                  if (v.requireSmsVerification._1) { return "(Just true)"; }
                  return "(Just false)";
                }
                if (v.requireSmsVerification.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["requiresMarketing", v.requiresMarketing ? "true" : "false"]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "restaurantId",
              Data$dShow.showIntImpl(v.restaurantId)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["start", Restaumatic$dCalendar$dTypes$dRestaurantLocalDay.showRestaurantLocalDay.show(v.start)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "visible",
              v.visible ? "true" : "false"
            ]))([])))))))))))))))))))));
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      };
    })())({reflectSymbol: () => "Promotion"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeAvailableAt = {
  unsafeDecode: /* #__PURE__ */ Unscramble$dEnum.genericUnsafeDecodeEnum(genericAvailableAt)(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Everywhere"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("DeliveryOnly"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("RestaurantOnly"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("TakeawayOnly"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("DeliveryAndTakeaway"), Data$dGeneric$dRep.NoArguments)]
  })({enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("RestaurantAndTakeaway"), Data$dGeneric$dRep.NoArguments)]}))))))(Unscramble$dEnum.defaultEnumOptions)
};
const unscrambleDecodePromotion = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "allowRosCouponsGeneration"})(Unscramble.decodeBoolean1)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "archived"
    })(Unscramble.decodeBoolean1)(Unscramble.decodeRecordCons({reflectSymbol: () => "availability"})(Restaumatic$dCalendar$dTypes$dAvailability.decodeWeeklyAvailability)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "availableAt"
    })(unscrambleDecodeAvailableAt)(Unscramble.decodeRecordCons({reflectSymbol: () => "combineTo"})(Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.udecodePromotionFilter)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "conditions"
    })(Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.unscrambleDecodePromotionConditions)(Unscramble.decodeRecordCons({reflectSymbol: () => "description"})(Unscramble.decodeMap(Restaumatic$dLocales.ufromJSONKeyLocale)(Restaumatic$dLocales.ordLocale)(Unscramble.decodeString1))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "enableAutoselect"
    })(Unscramble.decodeBoolean1)(Unscramble.decodeRecordCons({reflectSymbol: () => "enabledMenuConsumers"})(Unscramble.decodeSet(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.unscrambleDecodeMenuConsumer)(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.ordMenuConsumer))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "finish"
    })(Restaumatic$dCalendar$dTypes$dRestaurantLocalDay.unscrambleDecodeRestaurantLocalDay)(Unscramble.decodeRecordCons({reflectSymbol: () => "groupId"})(Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "imageUrl"
    })(Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordCons({reflectSymbol: () => "name"})(Unscramble.decodeMap(Restaumatic$dLocales.ufromJSONKeyLocale)(Restaumatic$dLocales.ordLocale)(Unscramble.decodeString1))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "prize"
    })(Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.unscrambleDecodePromotionPrize)(Unscramble.decodeRecordCons({reflectSymbol: () => "promotionId"})(Unscramble.decodeInt1)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "promotionType"
    })(Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.unscrambleDecodePromotionType)(Unscramble.decodeRecordCons({reflectSymbol: () => "requireSmsVerification"})(Unscramble.decodeMaybe(Unscramble.decodeBoolean1))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "requiresMarketing"
    })(Unscramble.decodeBoolean1)(Unscramble.decodeRecordCons({reflectSymbol: () => "restaurantId"})(Unscramble.decodeInt1)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "start"
    })(Restaumatic$dCalendar$dTypes$dRestaurantLocalDay.unscrambleDecodeRestaurantLocalDay)(Unscramble.decodeRecordCons({reflectSymbol: () => "visible"})(Unscramble.decodeBoolean1)(Unscramble.decodeRecordNil))))))))))))))))))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const boundedAvailableAt = /* #__PURE__ */ (() => (
  {
    top: genericAvailableAt.to(Data$dGeneric$dRep.$Sum(
      "Inr",
      Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))))
    )),
    bottom: genericAvailableAt.to(Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)),
    Ord0: () => ordAvailableAt
  }
))();
const enumAvailableAt = {
  succ: /* #__PURE__ */ Data$dEnum$dGeneric.genericSucc(genericAvailableAt)(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({"genericBottom'": Data$dGeneric$dRep.NoArguments}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  }))({"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  }))({"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)})),
  pred: /* #__PURE__ */ Data$dEnum$dGeneric.genericPred(genericAvailableAt)(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({"genericBottom'": Data$dGeneric$dRep.NoArguments}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  }))({"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  }))({"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)})),
  Ord0: () => ordAvailableAt
};
const boundedEnumAvailableAt = /* #__PURE__ */ (() => (
  {
    cardinality: Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))))))[
      "genericCardinality'"
    ],
    toEnum: Data$dEnum$dGeneric.genericToEnum(genericAvailableAt)(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))))))),
    fromEnum: (() => {
      const $0 = Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))))));
      return x => $0["genericFromEnum'"](genericAvailableAt.from(x));
    })(),
    Bounded0: () => boundedAvailableAt,
    Enum1: () => enumAvailableAt
  }
))();
const encodeAvailableAt = {
  encode: x => {
    const $0 = genericAvailableAt.from(x);
    if ($0.tag === "Inl") { return "Everywhere"; }
    if ($0.tag === "Inr") {
      if ($0._1.tag === "Inl") { return "DeliveryOnly"; }
      if ($0._1.tag === "Inr") {
        if ($0._1._1.tag === "Inl") { return "RestaurantOnly"; }
        if ($0._1._1.tag === "Inr") {
          if ($0._1._1._1.tag === "Inl") { return "TakeawayOnly"; }
          if ($0._1._1._1.tag === "Inr") {
            if ($0._1._1._1._1.tag === "Inl") { return "DeliveryAndTakeaway"; }
            if ($0._1._1._1._1.tag === "Inr") { return "RestaurantAndTakeaway"; }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  }
};
const encodePromotion = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericPromotion)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "Promotion"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
      reflectSymbol: () => "visible"
    })({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "start"})({
      encodeWithOptions: v => Restaumatic$dCalendar$dTypes$dRestaurantLocalDay.encodeRestaurantLocalDay.encode
    }))({reflectSymbol: () => "restaurantId"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "requiresMarketing"})({
      encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
    }))({reflectSymbol: () => "requireSmsVerification"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "promotionType"})({encodeWithOptions: v => Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.encodePromotionType.encode}))({
      reflectSymbol: () => "promotionId"
    })({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "prize"})({
      encodeWithOptions: v => Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.encodePromotionPrize.encode
    }))({reflectSymbol: () => "name"})((() => {
      const $0 = Restaumatic$dI18n$dTypes.encodeTranslated(Foreign$dGeneric$dClass.stringEncode);
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "imageUrl"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "groupId"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "finish"})({encodeWithOptions: v => Restaumatic$dCalendar$dTypes$dRestaurantLocalDay.encodeRestaurantLocalDay.encode}))({
      reflectSymbol: () => "enabledMenuConsumers"
    })((() => {
      const $0 = Data$dSet$dSerialized.encodeSet(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.encodeMenuConsumer);
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "enableAutoselect"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "description"})((() => {
      const $0 = Restaumatic$dI18n$dTypes.encodeTranslated(Foreign$dGeneric$dClass.stringEncode);
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "conditions"})({encodeWithOptions: v => Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.encodePromotionConditions.encode}))({
      reflectSymbol: () => "combineTo"
    })({encodeWithOptions: v => Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.encodePromotionFilter.encode}))({reflectSymbol: () => "availableAt"})({
      encodeWithOptions: v => encodeAvailableAt.encode
    }))({reflectSymbol: () => "availability"})({encodeWithOptions: v => Restaumatic$dCalendar$dTypes$dAvailability.encodeWeeklyAvailability.encode}))({
      reflectSymbol: () => "archived"
    })({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "allowRosCouponsGeneration"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeAvailableAt = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumDecode(genericAvailableAt)(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({
    reflectSymbol: () => "Everywhere"
  }))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({
    reflectSymbol: () => "DeliveryOnly"
  }))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({
    reflectSymbol: () => "RestaurantOnly"
  }))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({
    reflectSymbol: () => "TakeawayOnly"
  }))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({
    reflectSymbol: () => "DeliveryAndTakeaway"
  }))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({reflectSymbol: () => "RestaurantAndTakeaway"})))))))
};
const decodePromotion = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericPromotion)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "Promotion"})(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "visible"
  })({decodeWithOptions: v => Foreign.readBoolean(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "start"})({
    decodeWithOptions: v => Restaumatic$dCalendar$dTypes$dRestaurantLocalDay.decodeRestaurantLocalDay.decode
  })())({reflectSymbol: () => "restaurantId"})({decodeWithOptions: v => Foreign.readInt(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "requiresMarketing"})({
    decodeWithOptions: v => Foreign.readBoolean(Data$dIdentity.monadIdentity)
  })())({reflectSymbol: () => "requireSmsVerification"})({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readBoolean(Data$dIdentity.monadIdentity))})())({
    reflectSymbol: () => "promotionType"
  })({decodeWithOptions: v => Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.decodePromotionType.decode})())({reflectSymbol: () => "promotionId"})({
    decodeWithOptions: v => Foreign.readInt(Data$dIdentity.monadIdentity)
  })())({reflectSymbol: () => "prize"})({decodeWithOptions: v => Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.decodePromotionPrize.decode})())({
    reflectSymbol: () => "name"
  })(/* #__PURE__ */ (() => {
    const $0 = Restaumatic$dI18n$dTypes.decodeTranslated(Foreign$dGeneric$dClass.stringDecode);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "imageUrl"})({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))})())({
    reflectSymbol: () => "groupId"
  })({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))})())({reflectSymbol: () => "finish"})({
    decodeWithOptions: v => Restaumatic$dCalendar$dTypes$dRestaurantLocalDay.decodeRestaurantLocalDay.decode
  })())({reflectSymbol: () => "enabledMenuConsumers"})(/* #__PURE__ */ (() => {
    const $0 = Data$dSet$dSerialized.decodeSet(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.ordMenuConsumer)(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.decodeMenuConsumer);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "enableAutoselect"})({decodeWithOptions: v => Foreign.readBoolean(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "description"})(/* #__PURE__ */ (() => {
    const $0 = Restaumatic$dI18n$dTypes.decodeTranslated(Foreign$dGeneric$dClass.stringDecode);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "conditions"})({decodeWithOptions: v => Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.decodePromotionConditions.decode})())({
    reflectSymbol: () => "combineTo"
  })({decodeWithOptions: v => Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.decodePromotionFilter.decode})())({reflectSymbol: () => "availableAt"})({
    decodeWithOptions: v => decodeAvailableAt.decode
  })())({reflectSymbol: () => "availability"})({decodeWithOptions: v => Restaumatic$dCalendar$dTypes$dAvailability.decodeWeeklyAvailability1.decode})())({
    reflectSymbol: () => "archived"
  })({decodeWithOptions: v => Foreign.readBoolean(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "allowRosCouponsGeneration"})({
    decodeWithOptions: v => Foreign.readBoolean(Data$dIdentity.monadIdentity)
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  $AvailableAt,
  DeliveryAndTakeaway,
  DeliveryOnly,
  Everywhere,
  Promotion,
  RestaurantAndTakeaway,
  RestaurantOnly,
  TakeawayOnly,
  boundedAvailableAt,
  boundedEnumAvailableAt,
  decodeAvailableAt,
  decodePromotion,
  encodeAvailableAt,
  encodePromotion,
  enumAvailableAt,
  eqAvailableAt,
  eqPromotion,
  genericAvailableAt,
  genericPromotion,
  hasFieldPromotion,
  newtypePromotion_,
  ordAvailableAt,
  showAvailableAt,
  showPromotion,
  unscrambleDecodeAvailableAt,
  unscrambleDecodePromotion
};
